'use client';

import type { Product } from '@repo/shopify';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { buildSearchEvent, trackAnalyticsEvent } from '@/lib/analytics/client';
import { searchEventTracker } from '@/lib/analytics/search-tracking';

interface SearchAnalyticsProps {
	query: string;
	products: Product[];
	totalCount: number;
}

export function SearchAnalytics({ query, products, totalCount }: SearchAnalyticsProps) {
	const pathname = usePathname();

	useEffect(() => {
		return searchEventTracker.schedule(pathname, query, () => {
			trackAnalyticsEvent(buildSearchEvent({ query, products, totalCount }));
		});
	}, [pathname, products, query, totalCount]);

	return null;
}
